import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type GoToIconProps = {
    color?: string
    size?: number
    className?: ClassName
    style?: React.CSSProperties
}

export function GoToIcon({ className, style, size = 22, color = '#000' }: GoToIconProps): React.ReactElement {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
            data-testid={'goToIcon'}
        >
            <g clipPath="url(#clip0_2453_18296)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.3128 18.3378L3.66218 18.3211V3.66218H9.32529V2H3.67889C2.75174 2 2 2.75174 2 3.67889V18.3211C2 19.2483 2.75174 20 3.67889 20H18.3211C19.2483 20 20 19.2483 20 18.3211V12.6664H18.3211V18.3295L18.3128 18.3378ZM14.4783 6.18184L9.75336 10.9068L10.9346 12.0881L15.6596 7.36308L14.4783 6.18184ZM18.3211 5.34107C18.3295 4.45568 17.5527 3.67889 16.659 3.67889H13.8107L12.1318 2H16.659C17.5443 2 18.3963 2.34246 19.0228 2.97726C19.6492 3.61206 20 4.44733 20 5.34107V9.86821L18.3211 8.18933V5.34107Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_2453_18296">
                    <rect width="18" height="18" fill="white" transform="translate(2 2)" />
                </clipPath>
            </defs>
        </svg>
    )
}
